import moment from 'moment';
import {
  SET_ITEMS,
  SET_TOTAL,
  SET_CRITERE_RECHERCHE,
  SET_BRIEF,
  SET_PANIER,
  ADD_LIGNE_IN_PANIER,
  DELETE_LIGNE_IN_PANIER,
  SET_LIGNES_COMMANDE,
  CLEAR_PANIER,
  CLEAR_LIGNES_COMMANDE,
  SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO,
  SET_LAST_PAYLOAD,
} from '@/store/modules/produitReseauTempo-mutation-type';
import * as allTypes from '@/store/mutation-type';
import { getAll } from '@/api/produit/produitReseau';
import { getAllPlanning } from '@/api/dispo';
import genererCritereRecherche
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauTempo';
import getLogo from '@/services/general/getLogo';

function initialState() {
  return {
    items: [],
    total: 0,
    criteresRecherche: genererCritereRecherche(),
    brief: genererCritereRecherche(),
    panier: [],
    lignesCommande: [],
    isFromListReseauTempoDispo: false,
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [SET_ITEMS](state, items) {
    state.items = items;
  },
  [SET_TOTAL](state, total) {
    state.total = total;
  },
  [SET_CRITERE_RECHERCHE](state, criteresRecherche) {
    state.criteresRecherche = criteresRecherche;
  },
  [SET_BRIEF](state, brief) {
    state.brief = brief;
  },
  [SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO](state, isFromListReseauTempoDispo) {
    state.isFromListReseauTempoDispo = isFromListReseauTempoDispo;
  },
  [SET_PANIER](state, panier) {
    state.panier = panier;
  },
  [CLEAR_PANIER](state) {
    state.panier = [];
  },
  [CLEAR_LIGNES_COMMANDE](state) {
    state.lignesCommande = [];
  },
  [DELETE_LIGNE_IN_PANIER](state, idProduit) {
    const index = state.panier.findIndex((lignePanier) => {
      return lignePanier.id === idProduit;
    });
    if (index !== -1) {
      state.panier.splice(index, 1);
    }
  },
  async [ADD_LIGNE_IN_PANIER](state, produit) {
    produit.logo = await getLogo(produit.id);
    state.panier.push(produit);
  },
  [SET_LIGNES_COMMANDE](state, lignesCommande) {
    state.lignesCommande = lignesCommande;
  },
  [SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadProduits({ commit }, data) {
    commit(SET_LAST_PAYLOAD, data);
    const result = await getAll(data);
    const dateDebut = moment(data.query.dateVisualisation).startOf('week').toDate();
    const dateFin = moment(data.query.dateVisualisation).endOf('week').toDate();
    let allDipos = [];
    if (result.data.result.totalCount > 0) {
      allDipos = (await getAllPlanning(result.data.result.items.map((reseauTempo) => {
        return reseauTempo.id;
      }), dateDebut, dateFin)).data.result;
    }
    result.data.result.items.forEach((produitReseauTempo) => {
      produitReseauTempo.selected = false;
      produitReseauTempo.nbFacesPrevues = 0;
      const dispoFind = allDipos[produitReseauTempo.id];
      dispoFind.forEach((dispo) => {
        produitReseauTempo.nbFacesPrevues += dispo.stock;
      });
    });
    commit(SET_ITEMS, result.data.result.items);
    commit(SET_TOTAL, result.data.result.totalCount);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  brief: state => {
    return state.brief;
  },
  panier: state => {
    return state.panier;
  },
  lignesCommande: state => {
    return state.lignesCommande;
  },
  isFromListReseauTempoDispo: state => {
    return state.isFromListReseauTempoDispo;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
